import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { hideModal } from '../../../actions/modal';
import { editProfileData, updatePassword } from '../../actions/personalInfo';
import { getFieldsFromDateAsFormat } from '../../../utils/dateFormatter';
import { login } from '../../../userauth/actions/signinAction';
import { validateEmail, validatePassword } from '../../../utils/inputValidator';
import Loader from '../../../components/common/Loader';
import { getUaas } from '../../../refresh/selectors/featureFlagsSelector';
import { checkMyJioRedirection } from '../../../refresh/utils/myJioUtils';

class UpdatePasswordPopup extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      newPwd: '',
      errPwd: '',
      disableCTA: true
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    ga('send', {
      eventCategory: 'buttonTap',
      eventAction: 'Change Personal Info',
      eventLabel: 'Save New Password'
    });
    const { newPwd = '', errPwd = '' } = this.state;
    if (newPwd && validatePassword(newPwd)) {
      let { source = '' } = this.props;
      let profileFormData = {
        firstName: '',
        lastName: '',
        screenName: '',
        dateOfBirth: '',
        mobileNumber: '',
        genderType: '',
        newPassword: newPwd,
        confirmPassword: newPwd
      };
      if (this.props.isUaasFlagOn) {
        profileFormData = {
          newPassword: newPwd,
          confirmPassword: newPwd,
          isPasswordChange: true
        };
      }
      this.setState({
        errPwd: ''
      });
      const { isUaasFlagOn = false } = this.props;
      this.props.updatePassword(profileFormData, isUaasFlagOn);
    } else if (!validatePassword(newPwd)) {
      this.setState({
        newPwd: '',
        errPwd:
          'Password should have a minimum of 8 characters with atleast one number, one alphabet and one special character.'
      });
    }
  };

  render() {
    return (
      <form
        className="update-mobile-form"
        id="updatePasswordForm"
        noValidate
        onSubmit={this.handleSubmit}
      >
        <Loader name="mobile-num-popup" />
        <p className="update-mobile-no-text">
          {' '}
          <strong>Enter New Password</strong>{' '}
        </p>
        <div className="update-mob-input-field-block">
          <div className="password-id">
            <input
              className="update-mobile-mod-input"
              name="newEmail"
              size="32"
              maxLength="254"
              type="password"
              value={this.state.newPwd}
              onChange={e => {
                let cta = this.state.disableCTA;
                if (e.target.value !== '') cta = false;
                else cta = true;
                this.setState({
                  newPwd: e.target.value,
                  disableCTA: cta
                });
              }}
            />
            <label htmlFor="newEmail" className="newEmailLabel">
              Enter Password
            </label>
            {this.state.errPwd && <div className="err-msg-email">{this.state.errPwd}</div>}
          </div>

          <div className="mobaddaddr-type">
            <input
              type="submit"
              placeholder="save"
              disabled={this.state.disableCTA}
              className="update-mobile-mod-verify update-email-popup"
              value="SAVE NEW PASSWORD"
            />
          </div>
        </div>
      </form>
    );
  }
}

const mapStatetoProps = state => {
  const { personalInfo = {}, signInReducer = {} } = state;
  const { validUser = false } = signInReducer;
  const { emailUpdate = {}, profile: { screenName = '' } = {} } = personalInfo;
  const { statusCode = '', message = '', type = '' } = emailUpdate;
  const isMyJioRedirection = checkMyJioRedirection();
  return {
    statusCode,
    message,
    type,
    validUser,
    screenName,
    isUaasFlagOn: getUaas(state) || isMyJioRedirection
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updatePassword: (formData, flag) => {
      dispatch(updatePassword(formData, flag));
    },
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    }
  };
};
export default UpdatePasswordPopup = connect(
  mapStatetoProps,
  mapDispatchToProps
)(UpdatePasswordPopup);
